module.exports = __webpack_public_path__ + "io_name.svg?48d5302c2003f26a5e4a687dfe9d6480";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/io_name.svg
// module id = 17
// module chunks = 0